import type { Nullable } from "@shared-kernel/core/types/nullable";

export enum CONTRACT_SIGNATORY_TYPE {
  LEGAL_REPRESENTATIVE = "legal_representative",
  DELEGATE = "delegate",
}

// The legal representative carries no data of their own: their name is the request's, their email the provider's.
export type ContractSignatory =
  | { type: CONTRACT_SIGNATORY_TYPE.LEGAL_REPRESENTATIVE }
  | { type: CONTRACT_SIGNATORY_TYPE.DELEGATE; firstName: string; lastName: string; email: string };

export const isDelegateSignatoryType = (type: Nullable<CONTRACT_SIGNATORY_TYPE>): boolean => type === CONTRACT_SIGNATORY_TYPE.DELEGATE;
